import React from "react";
import { Col, Row } from "react-bootstrap";
import FormFields from "../../atoms/FormFields";
import "./manageinvestment.scss";
import Buttons from "../../atoms/Buttons";
import { Icons } from "../../atoms/Icons";
import { Link } from "react-router-dom";

const ManageInvestmentModal = (props) => {
  return (
    <div className="manageInvestmentPage">
      <Row>
        <Col>
          <div className="mi-small-close">
            <Link to="" aria-label="close manage investment modal">
              <Icons
                iconname="close"
                variant="icon-sixteen-px"
                clickHandler={props.handleCloseButton}
              />
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="mi-title">
          <div>Manage investments</div>
        </Col>
      </Row>
      <Row className="mi-text">
        <Row className="mi-membership-field mb-3">
          <div>You have chosen to change investments for</div>
        </Row>
        <Row className="d-none d-xl-block d-lg-block d-md-block mb-2">
          <FormFields
            variant="form-field-manage-investment"
            disabled={true}
            value={
              props?.memberships?.memberships[0]?.membershipId +
              " " +
              props?.memberships?.memberships[0]?.membershipName
            }
          />
        </Row>
        <div className="mi-membership-strategy mb-3 d-block d-sm-none">
          {props?.memberships?.memberships[0]?.membershipId +
            " " +
            props?.memberships?.memberships[0]?.membershipName}
        </div>
        <Row className="mi-membership-field mb-2">
          <div>For</div>
        </Row>
        <Row className="d-none d-xl-block d-lg-block d-md-block mb-2">
          <FormFields
            variant="form-field-manage-investment"
            disabled={true}
            value={props.investmentStrategy}
          />
        </Row>
        <div className="mi-membership-strategy mb-3 d-block d-sm-none">
          <div>{props.investmentStrategy}</div>
        </div>
        <Row>
          {/* {props?.memberships?.memberships?.length ===
          props?.data?.memberships?.length ? (
            ""
          ) : ( */}
          <div className="mi-membership-field mb-3">
            This instruction will not affect any other pots and investments you
            may have with TPT.
          </div>
          {/* )} */}
        </Row>
      </Row>
      <Row>
        <div className="mi-container-button">
          <div>
            <Buttons
              className="secondary"
              name="Back"
              handleClick={props.handleBackButton}
            />
          </div>
          <div className="mi-continue-button">
            <Buttons
              className="primary"
              name="Continue"
              disabled={false}
              handleClick={props.handleManageInvestmentContinue}
            />
          </div>
        </div>
      </Row>
    </div>
  );
};

export default ManageInvestmentModal;
